import React, { useState } from 'react'
import { login, register } from '../../actions';
import { useDispatch } from 'react-redux'

function Login() {
  const [datos, setDatos] = useState({})
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch()


  // const handleLogin = (e) => {
  //   e.preventDefault();
  //   dispatch(login())
  //   console.log(e.target.elements[0].value,'vañue')
  // }
  // const handleRegister = (e) => {
  //   e.preventDefault();
  //   dispatch(register())
  // }
  const handleChange = (e) => {
    setDatos({ ...datos, [e.target.name]: e.target.value });
    // console.log(e.target.name)
  }
  // console.log(datos,'datoss')
  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(login(datos))
  }
  const handleSign = (e) => {
    e.preventDefault();
    dispatch(register(datos))
  }

  const changemodal = () => {
    setModal(!modal)
  }

  return (
    <div>
      {modal===false?
      <div>
      <form onSubmit={handleLogin}>
        <label>
          Nombre:
          <input type="text" name="email" onChange={handleChange} />
        </label>
        <label>
          Constraseña:
          <input type="password" name="password" onChange={handleChange} />
        </label>
        <button type="submit">Iniciar Sesion</button>
      </form>
        <button onClick={changemodal}>Sign Up</button>
    </div>
    :
    <div>
        <form onSubmit={handleSign}>
          <label>
            Nombre:
            <input type="text" name="email" onChange={handleChange} />
          </label>
          <label>
            Constraseña:
            <input type="password" name="password" onChange={handleChange} />
          </label>
          <button type="submit">Registrarse</button>
        </form>
        <button onClick={changemodal}>Login</button>
      </div>
    }

    </div>
  )
}

export default Login